import React, { MouseEvent } from 'react';
import { useTranslation } from 'react-i18next';

// MUI
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Switch from '@mui/material/Switch';
import Typography from '@mui/material/Typography';

// MUI Icons
import ViewColumnIcon from '@mui/icons-material/ViewColumn';

// Custom Components
import TableHeaderButton from './TableHeaderButton';
import { IMenuState } from '@/@types/ui/Table';

const TableHeaderButtonColumnPicker = (props: any) => {
  const { t } = useTranslation();
  const { columns, smallButtons } = props;

  const [menuState, setMenuState] = React.useState<IMenuState>({
    open: false,
    anchorEl: null,
  });

  const handleOpen = (evt: MouseEvent<HTMLButtonElement>) => {
    setMenuState({ open: true, anchorEl: evt.currentTarget });
  };

  const handleClose = () => {
    setMenuState({ open: false, anchorEl: null });
  };

  return (
    <>
      <TableHeaderButton
        startIcon={<ViewColumnIcon />}
        variant="outlined"
        onClick={handleOpen}
        smallButtons={smallButtons}
        tooltip={t('buttons.toggle_columns') ?? ''}
      >
        {t('buttons.toggle_columns')}
      </TableHeaderButton>
      <Menu
        open={menuState.open}
        onClose={handleClose}
        anchorEl={menuState.anchorEl}
        transformOrigin={{
          vertical: 'center',
          horizontal: 'right',
        }}
      >
        {columns
          .filter((col: any) => col.columnDef.header !== '')
          .map((c: any, i: number) => (
            <MenuItem
              value={i}
              key={c.columnDef.header}
              onClick={c.getToggleVisibilityHandler()}
              sx={{
                height: { xs: 22, sm: 24, md: 26, lg: 28, xl: 35 },
                px: { xs: 1, sm: 1, md: 1, lg: 1, xl: 1.5 },
                py: { xs: 0, sm: 0, md: 0, lg: 0, xl: 3 },
                gap: { xs: 1, sm: 1, md: 1, lg: 1, xl: 1.5 },
              }}
            >
              <Switch
                color="primary"
                checked={c.getIsVisible()}
                onChange={c.getToggleVisibilityHandler()}
                sx={{
                  transform: {
                    xs: 'scale(0.8)',
                    sm: 'scale(0.8)',
                    md: 'scale(0.8)',
                    lg: 'scale(0.8)',
                    xl: 'scale(1)',
                  },
                }}
              />

              <Typography
                variant="caption"
                sx={{
                  textTransform: 'uppercase',
                  fontWeight: 600,
                  fontSize: {
                    xs: '0.65rem',
                    sm: '0.75rem',
                    md: '0.65rem',
                    lg: '0.65rem',
                    xl: '0.8rem',
                  },
                }}
              >
                {t(c.columnDef.header as string)}
              </Typography>
            </MenuItem>
          ))}
      </Menu>
    </>
  );
};

export default TableHeaderButtonColumnPicker;
